import { IConfiguration } from "./IConfiguration";

export const TEST = {
	headerAuthWidgetsApiUrl: "https://findum-widgets-test.sendum.com",
	headerAuthWidgetsApiVersion: "v1",
	baseApiPath: "widget",
	mqttPrefix: "test-",
	awsRegion: "",
	cognitoAuthWidgetsApiUrl: "https://ibaubvm5aa.execute-api.us-east-2.amazonaws.com",
	cognitoAuthWidgetsApiVersion: "stage",
	cognitoAuthApiUrl: "",
	cognitoAuthApiVersion: "",
	cognitoIdentityPoolId: "",
	cognitoAuthProviderName: "",
	voyagerApiUrl: "",
	voyagerApiVersion: ""
} as IConfiguration;
